<template lang="html">
<div class="coupon-list">
  <row>
    <div class="sl-col-4">
      <div class="sl-coupon-form">
        <div class="sl-btn-list">
          <router-link  tag="el-button" class="sl-el-btn sl-btn-green" :to="{ name: 'Choose-Coupon'}" @click.native="$ga.event('Button', '+ Create New Coupon', 'Coupons')">+ {{$t('Views.Coupons.CNC')}}</router-link>
        </div>
        <div class="sl-table-list" v-loading="validLoading">
          <div class="title">{{$t('Views.Coupons.AC')}}</div>
          <div class="list">
            <div class="no-item" v-if="valid.length === 0">{{$t('Views.Coupons.none')}}</div>
            <div class="item" v-for="item,index in valid">
              <img src="../../assets/imgs/coupon.png" v-if="$route.query.new === 1 && index === 0">
              <div class="item-top">
                <div class="item-top-title" style="-webkit-box-orient: vertical;">{{item.name}}</div>
                <div class="item-top-time">{{item.dateRange}}</div>
              </div>
              <div class="item-middle"></div>
              <div class="item-bottom">
                <div class="item-top-title">{{item.redeem}} {{$t('Views.Coupons.redeem')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sl-table-list" v-loading="invalidLoading">
          <div class="title">{{$t('Views.Coupons.IC')}}</div>
          <div class="list">
            <div class="no-item" v-if="valid.length === 0">{{$t('Views.Coupons.none')}}</div>
            <div class="item item-invalid" v-for="item in invalid">
              <div class="item-top">
                <div class="item-top-title" style="-webkit-box-orient: vertical;">{{item.name}}</div>
                <div class="item-top-time">{{$t('Views.Coupons.invalid')}}</div>
              </div>
              <div class="item-middle"></div>
              <div class="item-bottom">
                <div class="item-top-title">{{item.redeemed}} {{$t('Views.Coupons.redeem')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </row>
</div>
</template>
<script>
import api from '../../api'
export default {
  created() {
    const params = {
      per: 100,
      page: 1
    }
    const vm = this
    this.validLoading = true
    this.invalidLoading = true
    api.FetchCouponList(Object.assign({
      status: 1
    }, params)).then(res => {
      vm.valid = res.data.list.map(item => vm.formatCoupon(item.typeId, item))
      vm.validLoading = false
    })
    api.FetchCouponList(Object.assign({
      status: 99
    }, params)).then(res => {
      vm.invalid = res.data.list.map(item => vm.formatCoupon(item.typeId, item))
      vm.invalidLoading = false
    })
  },
  data() {
    return {
      invalid: [],
      valid: [],
      validLoading: false,
      invalidLoading: false
    }
  },
  methods: {
    formatCoupon(id, item) {
      if (id === '1') {
        item.name = item.name.replace('_X', item.discount).replace('&Merchant Name', this.$store.state.user.userinfo.merchantName)
      } else if (id === '2') {
        item.name = item.name.replace('_A', item.minSpending).replace('_S', item.discountPrice).replace('&Merchant Name', this.$store.state.user.userinfo.merchantName)
      } else if (id === '3') {
        item.name = item.name.replace('_A', item.minSpending).replace('_X', item.discount).replace('&Merchant Name', this.$store.state.user.userinfo.merchantName)
      }
      return item
    }
  }
}
</script>
<style scoped>
.item img {
  position: absolute;
}

.sl-coupon-form>div {
  padding: 20px;
}

.sl-btn-list {
  border-bottom: 1px solid #E0E0E0;
}

.sl-table-list .title {
  font-family: Avenir-Medium;
  font-size: 16px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 16px;
}

.sl-table-list .list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  min-height: 220px;
}

.sl-table-list .list .item {
  width: 210px;
  height: 220px;
  background: #FFFFFF;
  border-radius: 6px;
  margin-top: 20px;
  margin-right: 20px;
}

.sl-table-list .list .item-top {
  width: 210px;
  height: 160px;
  border: 1px solid #CCCCCC;
  border-radius: 6px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: none;
  position: relative;
}

.sl-table-list .list .item-top .item-top-title {
  font-family: Avenir-Medium;
  font-size: 20px;
  color: #2B90E9;
  letter-spacing: 0;
  line-height: 28px;
  height: 84px;
  margin-top: 20px;
  padding: 0 10px;
  text-align: center;
  width: 200px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.sl-table-list .list .item-top .item-top-time {
  font-family: Avenir-Medium;
  font-size: 12px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 13px;
  text-align: center;
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.sl-table-list .list .item-middle {
  height: 20px;
  width: 210px;
  background-image: url(../../assets/imgs/coupon_line_white.png);
  background-repeat: no-repeat;
}

.sl-table-list .list .item-bottom {
  font-family: Avenir-Medium;
  font-size: 12px;
  color: #000000;
  letter-spacing: 0;
  line-height: 13px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 210px;
  border: 1px solid #CCCCCC;
  border-radius: 6px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-top: none;
}

.sl-table-list .list .item.item-invalid {
  background: #FBFBFB;
}

.sl-table-list .list .item-invalid .item-middle {
  background-image: url(../../assets/imgs/coupon_line_gray.png);
}

.sl-table-list .list .item-invalid .item-top .item-top-title {
  color: #9B9B9B;
}

.sl-table-list .list .item-invalid .item-bottom {
  color: #9B9B9B;
}

.coupon-list .no-item {
  text-align: center;
  width: 100%;
  height: 220px;
  line-height: 220px;
}
</style>



// WEBPACK FOOTER //
// coupon-list.vue?ceebd336